import useApi from '@components/Hooks/useApi';
import useGlobalState from '@components/Hooks/useGlobalState';
import { IEvent } from '@src/interfaces';
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';

const ChangePasswordForm: React.FC = () => {

  const [, dispatch] = useGlobalState();
  const api = useApi(dispatch);

  const [old_password, setOldPassword] = useState<string>('');
  const [new_password, setNewPassword] = useState<string>('');
  const [new_password2, setNewPassword2] = useState<string>('');

  const changePassword = (e: React.FormEvent) => {
    e.preventDefault();

    if (!old_password) {
      return showError('Missing current password');
    }
    if (!new_password) {
      return showError('Missing desired password');
    }
    if (!new_password2) {
      return showError('Missing second desired password');
    }
    if (new_password != new_password2) {
      return showError('Passwords do not match');
    }
    api.changePassword(old_password, new_password);
  }

  const showError = (message: string) => {
    dispatch({ type: 'DONE_CHANGE_PASSWORD', data: { result: '', _info: { success: false, message: message } } });
  }

  return (
    <form id='change-password-form' onSubmit={changePassword} className={api.isReallyLoading('changePassword') ? 'dim' : ''}>
      <Form.Group controlId='old_password' className='form-group'>
        <Form.Label>Current Password</Form.Label>
        <Form.Control
          type="password"
          // autoFocus
          value={old_password}
          onChange={(e: IEvent) => { setOldPassword(e.currentTarget.value) }}
        />
      </Form.Group>
      <Form.Group controlId='new_password' className='form-group'>
        <Form.Label>Desired Password</Form.Label>
        <Form.Control
          type="password"
          value={new_password}
          onChange={(e: IEvent) => { setNewPassword(e.currentTarget.value) }}
        />
      </Form.Group>
      <Form.Group controlId='new_password2' className='form-group'>
        <Form.Label>Confirm Desired Password</Form.Label>
        <Form.Control
          type="password"
          value={new_password2}
          onChange={(e: IEvent) => { setNewPassword2(e.currentTarget.value) }}
        />
      </Form.Group>
      <Form.Group style={{ marginTop: 19 }} className='form-group'>
        <Button variant='primary' type="submit" onClick={changePassword}>
          Change
        </Button>
      </Form.Group>
    </form>
  );
}

export default ChangePasswordForm;